<div class="invitation-already-checked text-center">
    <div class="invitation-already-checked__illu align-center">
        <img [src]="imageLink"
             [alt]="isAlreadyAccepted ? ('Invitation deja acceptee' | transloco) : ('Invitation deja rejetee' | transloco)" />
    </div>
    <div class="invitation-already-checked__content">
        <div class="invitation-already-checked__title">
            {{'Quelqu\'un vous a devance !' | transloco}}
        </div>
        <p class="invitation-already-checked__subtitle margin-bottom-50">
            <span
                  [innerHtml]="
                  isAlreadyAccepted 
            ? ('Un autre responsable legal de votre organisation a deja <strong>accepte</strong> cette invitation.' | transloco)
            : ('Un autre responsable legal de votre organisation a deja <strong>refuse</strong> cette invitation.' | transloco)">
            </span>
            <br />
            <span
                  [innerHtml]="
            isAlreadyAccepted
            ? ('Pour gerer votre nouveau partenaire <strong>$name$</strong>, rendez-vous dans votre Manager.' | transloco: {
            name:
            invitation.account.organization_name})
            : 'Pour connaitre les raisons de ce refus, contacter directement la personne au sein de votre organisation qui a traite cette invitation.' | transloco">
            </span>
            <div class="invitation-already-checked__buttons">
                <div class="dashboard-link">
                    <a [href]="managerLink"
                       mat-flat-button
                       color="primary">
                        <span>{{ isAlreadyAccepted ? ( 'Voir le profil du partenaire' | transloco ) : ( 'Aller au manager' | transloco ) }}</span>
                    </a>
                </div>
            </div>
    </div>
</div>
